<template>
  <div class="ws-textbox">
    <div v-if="displayFlight" class="block-item-flight row">
      <div class="container">
        <div class="row" :class="{'m-0': cloneFlightLegs.length <= 1}">
          <div v-if="cloneFlightLegs.length > 1" class="col-2 flex-leg">
            <template v-if="showBtnPrev">
              <div class="btn-leg" @click="onPressBtnLeg('prev', displayFlight.fltref)">
                <b-button style=" height: 100%; padding: 4px;" class="btn-popover">
                  <i class="fa fa-chevron-left"></i>
                </b-button>
              </div>
            </template>
          </div>
          <div class="col-8 p-0" :class="{'col-12': cloneFlightLegs.length <= 1}">
            <div class="row flight-info text-center">
              <div class="col-4 p-0">
                <div v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[0].enabled" class="col-flight-info">
                  <div>{{ lang['homepage_new'].SFS_LANG_ROW_1 }}</div>
                  <div class="airport-name text-dark">{{ displayFlight.dep }}</div>
                  <div class="flight-time-der">
                    {{ moment(displayFlight.std).format('D MMM') }}
                    <div :style="displayFlight.etd ? 'text-decoration: line-through' : ''">
                      {{ moment(displayFlight.std).format('HH:mm') }}
                    </div>
                    <div v-if="displayFlight.etd">
                      {{ moment(displayFlight.etd).format('HH:mm') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 p-0 col-flight-info">
                <div>
                  {{ !displayFlight.carrier ? displayFlight.flight_number : displayFlight.carrier + displayFlight.flight_no }}
                </div>
                <div class="frame-flight-img">
                  <img src="@/assets/images/flight.png" alt="No image" />
                </div>
                <div  v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[2].enabled" class="flight-status">
                  <p class="text-dark">{{ lang['homepage_new'].SFS_LANG_ROW_3 }}:</p>
                  <p
                    v-if="pax.fltref !== pax.first_fltref"
                    :class="{
                      'status-new-flight': pax.fltref !== pax.first_fltref
                    }"
                  >
                    {{ statusFlight }}
                  </p>
                  <p v-else class="status-flight">
                    <span v-if="displayFlight && displayFlight.irreg_reason">{{ lang['status_flight'][displayFlight.irreg_reason] || displayFlight.flight_status || displayFlight.status }}</span>
                    <span v-else>{{ lang['status_flight']['NO_IRREG'] || displayFlight.flight_status || displayFlight.status }}</span>
                  </p>
                </div>
              </div>
              <div class="col-4 p-0">
                <div v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[1].enabled" class="col-flight-info">
                  <div>{{ lang['homepage_new'].SFS_LANG_ROW_2 }}</div>
                  <div class="airport-name text-dark">{{ displayFlight.arr }}</div>
                  <div>
                    {{ moment(displayFlight.sta).format('D MMM') }}
                    <div :style="displayFlight.eta ? 'text-decoration: line-through' : ''">
                      {{ moment(displayFlight.sta).format('HH:mm') }}
                    </div>
                    <div v-if="displayFlight.eta">
                      {{ moment(displayFlight.eta).format('HH:mm') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="cloneFlightLegs.length > 1" class="col-2 flex-leg">
            <template v-if="showBtnNext">
              <div class="btn-leg" @click="onPressBtnLeg('next', displayFlight.fltref)">
                <b-button style=" height: 100%; padding: 4px;" class="btn-popover">
                  <i class="fa fa-chevron-right"></i>
                </b-button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListFlightInfo',
  props: {
    flightLegs: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      cloneFlightLegs: [],
      displayFlight: {},
      statusFlight: '',
    }
  },
  computed: {
    ...mapGetters({
      flight: 'Flight/Flight',
    }),

    fltRefDisplay(){
      return this.displayFlight.fltref || ''
    },

    showBtnNext(){
      const indexCurrentFlightDisplay = this.cloneFlightLegs.findIndex(flight => flight.fltref === this.fltRefDisplay)
      return indexCurrentFlightDisplay < this.cloneFlightLegs.length - 1
    },

    showBtnPrev(){
      const indexCurrentFlightDisplay = this.cloneFlightLegs.findIndex(flight => flight.fltref === this.fltRefDisplay)
      return indexCurrentFlightDisplay > 0
    },

  },
  watch: {
    flightLegs: {
      handler: function (newVal) {
        this.cloneFlightLegs = _.cloneDeep(newVal)
        this.displayFlight = this.cloneFlightLegs.find(flight => flight.isCurrentFlight)
      },
      deep: true
    },
    flight: function () {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.lang)) {
        this.setStatusFlight(this.displayFlight);
      }
    },
    lang: function () {
      if (!_.isEmpty(this.flight) && !_.isEmpty(this.pax)) {
        this.setStatusFlight(this.displayFlight);
      }
    },
    pax: function () {
      if (!_.isEmpty(this.flight) && !_.isEmpty(this.lang)) {
        this.setStatusFlight(this.displayFlight);
      }
    }
  },
  created() {
    this.cloneFlightLegs = _.cloneDeep(this.flightLegs)
    this.displayFlight = this.cloneFlightLegs.find(flight => flight.isCurrentFlight)
    this.setStatusFlight(this.displayFlight);
  },
  methods: {
    onPressBtnLeg(type, fltref) {
      if(type == 'next') {
        const indexCurrentFlightDisplay = this.cloneFlightLegs.findIndex(flight => flight.fltref === fltref)
        if(indexCurrentFlightDisplay == this.cloneFlightLegs.length - 1) {
          return
        }
        this.displayFlight = this.cloneFlightLegs[indexCurrentFlightDisplay + 1]
      }
      if(type == 'prev') {
        const indexCurrentFlightDisplay = this.cloneFlightLegs.findIndex(flight => flight.fltref === fltref)
        if(indexCurrentFlightDisplay == 0) {
          return
        }
        this.displayFlight = this.cloneFlightLegs[indexCurrentFlightDisplay - 1]
      }
    },
    setStatusFlight(newFlight) {
      if (!newFlight) return

      let self = this
      self.statusFlight = newFlight.irreg_reason || newFlight.flight_status || newFlight.status

      if (_.isUndefined(self.lang['status_flight'])) {
        return
      }

      if (self.pax.fltref !== self.pax.first_fltref) {
        self.statusFlight = self.lang['status_flight']['NEW_FLIGHT']
        return
      }

      self.statusFlight = newFlight.irreg_reason ? self.lang['status_flight'][newFlight.irreg_reason] : self.lang['status_flight']['NO_IRREG']
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .block-item-flight {
  .flight-info {
    color: #a4aabd;
    background-color: white;
    padding: 0;
    max-height: 166px;

    .col-flight-info {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }

  .frame-flight-img {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 70%;
      transform: var(--transform-flight-icon);
    }
  }

  .airport-name {
    font-size: 25pt;
  }

  .flight-status {
    margin: 10pt 0 0 0;
    letter-spacing: -0.3pt;
  }
}
.block-item {
  background-color: transparent !important;
}

.flex-leg{
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}
.btn-leg {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  min-height: 40%;
  border-radius: 12px;
  box-shadow: 0px 2px 5px rgba(51, 51, 51, 0.1);
  margin-top: 25px;
}
.flight-status span {
  color: #07bcec;
}

.btn-popover{
  i {
    font-weight: 900;
    margin: 0;
    font-size: 16px;
  }
}
</style>
